<template>
  <div class="common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">部门名称：</div>
          <div class="content">
            <el-select
              v-model="form.deptCode"
              clearable
              placeholder="请选择"
              filterable
              :loading="deptLoading"
            >
              <el-option v-for="item in deptList" :key="item.expeDeptCode" :label="item.expeDeptName" :value="item.expeDeptCode" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">查看人：</div>
          <div class="content">
            <el-select
              v-model="form.userName"
              clearable
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="userRemoteMethod"
              :loading="userLoading"
            >
              <el-option v-for="item in userList" :key="item.userId" :label="item.combination" :value="item.userName" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="addBtn">添加</el-button>
      <!-- <el-button plain :disabled="selectionList.length < 1" @click="batchDeleteHandle">删除</el-button> -->
    </div>
    <commonTable
      ref="budgetPerformancePermissionTable"
      @handleSelectChange="handleSelectChange"
      @handleCheckBoxAll="handleCheckBoxAll"
    />
    <addBudgetPerformancePermission
      ref="addBudgetPerformancePermission"
      :row-data="rowData"
      :add-dialog-visible="dialogVisible"
      @addBudgetPerformancePermissionHandle="addBudgetPerformancePermissionHandle"
      @editBudgetPerformancePermissionHandle="editBudgetPerformancePermissionHandle"
      @dialogCloseHandle="dialogCloseHandle"
    />
  </div>
</template>

<script>
import commonTable from '@/components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';
import addBudgetPerformancePermission from './component/budgetPerformancePermission/addBudgetPerformancePermission';
import { budgetPerformancePermissionApi, expensesJurManagementApi } from './service';

export default {
  name: 'BudgetPerformancePermission',
  data () {
    return {
      deptLoading: false,
      userLoading: false,
      form: {
        deptCode: '',
        userName: ''
      },
      deptList: [],
      userList: [],
      dialogVisible: false,
      rowData: {},
      selectionList: []
    };
  },
  components: {
    commonTable,
    addBudgetPerformancePermission
  },
  methods: {
    getRecordId (row) {
      return row.id || row.permissionId || row.permissionConfigId || '';
    },
    getRowValue (row, keys) {
      const targetKeys = Array.isArray(keys) ? keys : [keys];
      const key = targetKeys.find(item => row[item] !== undefined && row[item] !== null && row[item] !== '');
      return key ? row[key] : '--';
    },
    getDeptList () {
      this.deptLoading = true;
      expensesJurManagementApi.getExpenseDeptList().then(res => {
        if (res.status === '200') {
          this.deptList = res.data || [];
        }
        this.deptLoading = false;
      });
    },
    userRemoteMethod (query) {
      if (query && query.indexOf(' ') === -1) {
        this.userLoading = true;
        budgetPerformancePermissionApi.getAllSalesmanList(query).then(res => {
          if (res.status === '200') {
            this.userList = (res.data || []).map(item => {
              return {
                ...item,
                combination: `${item.userName}/${item.deptName}`
              };
            });
          }
          this.userLoading = false;
        });
      } else {
        this.userList = [];
      }
    },
    handleSelectChange ({ records }) {
      this.selectionList = records;
    },
    handleCheckBoxAll ({ records }) {
      this.selectionList = records;
    },
    editHandlen (row) {
      const id = this.getRecordId(row);
      if (!id) {
        this.$message.error('未获取到权限配置标识');
        return;
      }
      this.$store.commit('setSubPageLoading', true);
      budgetPerformancePermissionApi.getBudgetPerformancePermissionDetail(id).then(res => {
        if (res.status === '200') {
          this.rowData = res.data || {};
          this.dialogVisible = true;
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    deleteRequest (ids) {
      this.$store.commit('setSubPageLoading', true);
      budgetPerformancePermissionApi.deleteBudgetPerformancePermission({ ids }).then(res => {
        if (res.status === '200') {
          this.$message.success('删除成功');
          this.selectionList = [];
          if (this.$refs.budgetPerformancePermissionTable) {
            this.$refs.budgetPerformancePermissionTable.clearCheckboxReserve();
          }
          this.searchBtn();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    deleteHandle (row) {
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRequest([this.getRecordId(row)]);
      }).catch(() => {

      });
    },
    batchDeleteHandle () {
      const selectedRows = this.$refs.budgetPerformancePermissionTable.getCheckboxRecords();
      if (selectedRows.length < 1) {
        this.$message.error('请选择要删除的权限配置');
        return;
      }
      this.$confirm(`确定删除已选中的${selectedRows.length}条权限配置?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRequest(selectedRows.map(item => item.id));
      }).catch(() => {

      });
    },
    editBudgetPerformancePermissionHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      budgetPerformancePermissionApi.editBudgetPerformancePermission(data).then(res => {
        if (res.status === '200') {
          this.$message.success('编辑成功');
          this.dialogVisible = false;
          this.searchBtn();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    addBudgetPerformancePermissionHandle (data) {
      this.$store.commit('setSubPageLoading', true);
      budgetPerformancePermissionApi.addBudgetPerformancePermission(data).then(res => {
        if (res.status === '200') {
          this.$message.success('添加成功');
          this.dialogVisible = false;
          this.searchBtn();
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    dialogCloseHandle () {
      this.rowData = {};
      this.dialogVisible = false;
    },
    addBtn () {
      this.rowData = {};
      this.dialogVisible = true;
    },
    reset () {
      this.form = {
        deptCode: '',
        userName: ''
      };
      this.selectionList = [];
      this.searchBtn();
    },
    searchBtn () {
      this.selectionList = [];
      this.$refs.budgetPerformancePermissionTable.pageData.pageNum = 1;
      this.$refs.budgetPerformancePermissionTable.getTableData({ url: '/budget-performance-permission/queryList', params: this.form });
    },
    loadTable () {
      let tableRow = new TableRow();
      // tableRow.push(
      //   new TableColumns()
      //     ._width('60')
      //     ._others('checkbox')
      // );
      tableRow.push(
        new TableColumns()
          ._title('部门编码')
          ._width('140')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row }) => {
              return (
                <span>{ this.getRowValue(row, ['deptCode', 'departmentCode']) }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('部门名称')
          ._width('220')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row }) => {
              return (
                <span>{ this.getRowValue(row, ['deptName', 'departmentName']) }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('查看人')
          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row }) => {
              return (
                <span>{ this.getRowValue(row, ['userName', 'viewer']) }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('创建时间')
          ._width('140')
          ._data('createTime')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              if (!row[column.property]) {
                return (
                  <span>--</span>
                );
              }
              let date = new Date(row[column.property].replace(/-/g, '/')).format('yyyy-MM-dd');
              return (
                <span>{ date }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('创建人')
          ._width('120')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row }) => {
              return (
                <span>{ this.getRowValue(row, 'createUser') }</span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('160')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => { this.editHandlen(row); }}>
                    编辑
                  </el-button>
                  <el-button type="text" onClick={() => { this.deleteHandle(row); }}>
                    删除
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.budgetPerformancePermissionTable.setColumn(column, { rowId: 'id' });
      this.$refs.budgetPerformancePermissionTable.loadTable({ url: '/budget-performance-permission/queryList', listKey: 'list', params: this.form });
    }
  },
  mounted () {
    this.getDeptList();
    this.loadTable();
  }
};
</script>

<style scoped>
.common_button {
  margin-bottom: 16px;
}
</style>
